import React from 'react';
import Toast from './Toast';
import { useToast } from '../../hooks/useToast';

const ToastContainer: React.FC = () => {
  const { isVisible, config, hideToast } = useToast();

  if (!config) return null;

  return (
    <Toast
      isVisible={isVisible}
      type={config.type}
      message={config.message}
      onClose={hideToast}
      autoClose={config.autoClose}
      autoCloseDelay={config.autoCloseDelay}
    />
  );
};

export default ToastContainer; 